import React, { ReactNode } from 'react';
import Link from 'next/link';

interface ApiLayoutProps {
  children: ReactNode;
}

const ApiLayout: React.FC<ApiLayoutProps> = ({ children }) => {
  return (
    <div className="flex">
      <div className="w-1/4 bg-gray-200 h-screen">
        {/* Sidebar with links to API pages */}
        {/* You can replace this with your actual API endpoints */}
        <nav className="p-4 text-black">
          <ul>
            <li><Link href="/documentation">Introduction</Link></li>
            <li><Link href="/documentation/airtime">Airtime API</Link></li>
            <li><Link href="/documentation/data">Data API</Link></li>
            <li><Link href="/documentation/cable">Cable API</Link></li>
            <li><Link href="/documentation/vcable">Verify Cable API</Link></li>
            <li><Link href="/documentation/edu">Edu pins API</Link></li>
            <li><Link href="/documentation/vedu">Verify Edu API</Link></li>
            <li><Link href="/documentation/electric">Electricity API</Link></li>
            <li><Link href="/documentation/velectric">Verify Meter number API</Link></li>
            <li><Link href="/documentation/insure">Insurance API</Link></li>
          </ul>
        </nav>
      </div>
      <div className="w-3/4 p-8">
        {/* Main content area */}
        {children}
      </div>
    </div>
  );
};

export default ApiLayout;
